import { Component, ElementRef, EventEmitter, Inject, Input, Output } from '@angular/core';
import { fadeInOut } from '@shared/src/animations';
import { DeliveryLineColumns } from '@shared/src/components/route/delivery/lines/DeliveryLineColumns';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { Route_eCMRDto } from '@shared/src/dtos/route/cmr/Route_eCMRDto';
import { Route_eCMRAddressDTO } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRAddressDto';
import { Route_eCMRConditionsDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRConditionsDto';
import { Route_eCMRDeliveryLinesDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRDeliveryLinesDto';
import { Route_eCMRHandlingAndTransportationDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRHandlingAndTransportationDto';
import { Route_eCMRIncotermDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRIncotermDto';
import { Route_eCMRPartnerDTO } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPartnerDto';
import { Route_eCMRPaymentDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPaymentDto';
import { Route_eCMRPlatesDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPlatesDto';
import { Route_eCMRTransportDateDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRTransportDateDto';
import { Incoterms, SharedAsideFactory } from '@shared/src/public-api';

@Component({
  selector: 'shared-route-part-cmr-digitaldocument-editable-component',
  templateUrl: './shared.route.part.cmr.digitaldocument.editable.component.html',
  styleUrls: ['./shared.route.part.cmr.digitaldocument.editable.component.scss'],
  animations: [fadeInOut]
})
export class SharedRoutePartCMRDigitalDocumentEditableComponent {
  constructor(private routeCMRController: RouteCMRController,
    private openRouteCMRController: OpenRouteCMRController,
    @Inject('HomeController') protected homeController: HomeController,
    @Inject('SharedAsideFactory') protected sharedAsideFactory: SharedAsideFactory,
    private el: ElementRef) {
    if (homeController.useIonic) this.useIonic = homeController.useIonic();
  };

  ngOnInit() {

  }

  public incotermNone: Incoterms = Incoterms.none;
  public useIonic: boolean = false;


  @Input()
  public readonly: boolean = false;

  @Input()
  public contract: boolean = false;

  @Input()
  public external: boolean = false;

  public showAll: boolean = false;

  private _routePartCMRId: number;
  @Input()
  public set routePartCMRId(value: number) {
    if (this._routePartCMRId === value)
      return;
    this._routePartCMRId = value;
    this.loadCMR();
  }
  public get routePartCMRId(): number {
    return this._routePartCMRId;
  }

  public route_eCMR: Route_eCMRDto;
  loadCMR() {
    if (!HLong.isNullOrNullLong(this._routePartCMRId)) {
      if (!this.external) {
        this.routeCMRController.getRoute_eCMR(this._routePartCMRId).subscribe(e => {
          this.welcomeECMR(e);
        });
      } else {
        this.openRouteCMRController.getRoute_eCMR(this._routePartCMRId).subscribe(e => {
          this.welcomeECMR(e);
        });
      }

    }
  }
  /***
   * Columnes visibles de les línies de mercaderia en mode NOMÉS LECTURA:
   * les que no tenen valor a cap línia no es pinten (veure DeliveryLineColumns).
   */
  public deliveryLineColumns: DeliveryLineColumns = new DeliveryLineColumns();

  /*** Camps que suporta aquesta vista, sense filtrar per si hi ha dada (pel desplegable del chevron) */
  public deliveryLineColumnsSupported: DeliveryLineColumns = new DeliveryLineColumns();

  private refreshDeliveryLineColumns() {
    let lines = this.route_eCMR != null ? this.route_eCMR.deliveryLines : [];
    // Camps que aquesta vista (eCMR editable) sap pintar. Un camp que existeixi a
    // ECMRDeliveryLineDto però no sigui en aquesta llista queda amagat SEMPRE, sense
    // error (veure el comentari gran a DeliveryLineColumns.ts).
    let supported = ['reference', 'description', 'quantity', 'kg', 'netKg', 'boxes', 'bags', 'sacks', 'wDimension',
      'yDimension', 'hDimension', 'm3', 'palletCount', 'palletType', 'publicTags', 'batchInfo'];
    this.deliveryLineColumns = DeliveryLineColumns.compute(lines, false, supported);
    this.deliveryLineColumnsSupported = DeliveryLineColumns.compute(lines, true, supported);
    this.expandedDeliveryLine = null;
  }

  /***
   * Quina línia de mercaderia està desplegada. Aquesta vista és de només
   * lectura i no hereta de SharedDeliveryLinesBaseComponent, així que es
   * gestiona aquí: sense això el chevron es pintava però no feia res.
   */
  public expandedDeliveryLine: any = null;

  public onExpandedDeliveryLine(line: any) {
    this.expandedDeliveryLine = this.expandedDeliveryLine === line ? null : line;
  }

  public isDeliveryLineExpanded(line: any): boolean {
    return this.expandedDeliveryLine === line;
  }

  welcomeECMR(e: Route_eCMRDto) {
    if (e && e.eCMRId) {
      this.route_eCMR = e;
    }
    else
      this.route_eCMR = null;

    this.refreshDeliveryLineColumns();

    this.handlingAndTransportationExpanded = false;
    this.conditionsExpanded = false;
    this.incotermExpanded = false;
    this.updatePayment = false;

    this.updateOriginTenant = false;
    this.updateDestinationTenant = false;

    this.updateCarrier = false;
    this.updateEffectiveCarrier = false;
    this.updateDriver = false;
    this.updateApplicant = false;
    this.updatePayer = false;
    this.updateOriginAddress = false;
    this.updateDestinationAddress = false;

    this.updatePlates = false;
    this.updateTransportDate = false;

    this.deliveryLinesExpanded = false;

    this.addEvent = false;
  }


  obrirDireccio(addressId: number, formattedAddress: string) {
    this.sharedAsideFactory.invokeAddress(addressId, formattedAddress);
  }


  public conditionsExpanded: boolean = false;
  public handlingAndTransportationExpanded: boolean = false;
  public incotermExpanded: boolean = false;
  public updatePayment: boolean = false;

  public updateOriginTenant: boolean = false;
  public updateDestinationTenant: boolean = false;
  public updateDriver: boolean = false;
  public updateCarrier: boolean = false;
  public updateEffectiveCarrier: boolean = false;
  public updateApplicant: boolean = false;
  public updatePayer: boolean = false;

  public updateOriginAddress: boolean = false;
  public updateDestinationAddress: boolean = false;

  public updatePlates: boolean = false;
  public updateTransportDate: boolean = false;

  public deliveryLinesExpanded: boolean = false;

  public addEvent: boolean = false;

  resetIncoterm() {
    if (!this.external) {
      this.routeCMRController.updateIncoterm(this.routePartCMRId, Route_eCMRIncotermDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateIncoterm(this.routePartCMRId, Route_eCMRIncotermDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  incotermBlank(): boolean {
    return !this.route_eCMR || !this.route_eCMR.incoterm || this.route_eCMR.incoterm == Incoterms.none;
  }

  resetPayment() {
    if (!this.external) {
      this.routeCMRController.updatePayment(this.routePartCMRId, Route_eCMRPaymentDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updatePayment(this.routePartCMRId, Route_eCMRPaymentDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  paymentBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.payment || this.route_eCMR.amount >= 0);
  }

  resetOriginTenant() {
    if (!this.external) {
      this.routeCMRController.updateOriginTenant(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateOriginTenant(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  originTenantBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.originTenantId || this.route_eCMR.originTenantName || this.route_eCMR.originTenantNif || this.route_eCMR.originTenantContactName || this.route_eCMR.originTenantContactPhone || this.route_eCMR.originTenantAddress?.formattedAddress);
  }

  resetDestinationTenant() {
    if (!this.external) {
      this.routeCMRController.updateDestinationTenant(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateDestinationTenant(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  destinationTenantBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.destinationTenantId || this.route_eCMR.destinationTenantName || this.route_eCMR.destinationTenantNif || this.route_eCMR.destinationTenantContactName || this.route_eCMR.destinationTenantContactPhone || this.route_eCMR.destinationTenantAddress?.formattedAddress);
  }

  resetCarrier() {
    if (!this.external) {
      this.routeCMRController.updateCarrier(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateCarrier(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  carrierBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.carrierName || this.route_eCMR.carrierNif || this.route_eCMR.carrierContactName || this.route_eCMR.carrierContactPhone || this.route_eCMR.carrierAddress?.formattedAddress);
  }

  resetEffectiveCarrier() {
    if (!this.external) {
      this.routeCMRController.updateEffectiveCarrier(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateEffectiveCarrier(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  effectiveCarrierBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.effectiveCarrierName || this.route_eCMR.effectiveCarrierNif || this.route_eCMR.effectiveCarrierContactName || this.route_eCMR.effectiveCarrierContactPhone || this.route_eCMR.effectiveCarrierAddress?.formattedAddress);
  }

  resetDriver() {
    if (!this.external) {
      this.routeCMRController.updateDriver(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateDriver(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  driverBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.driverName || this.route_eCMR.driverNif || this.route_eCMR.driverPhone);
  }

  resetApplicant() {
    if (!this.external) {
      this.routeCMRController.updateApplicant(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateApplicant(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  applicantBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.applicantName || this.route_eCMR.applicantNif || this.route_eCMR.applicantContactName || this.route_eCMR.applicantContactPhone || this.route_eCMR.applicantAddress?.formattedAddress);
  }

  resetPayer() {
    if (!this.external) {
      this.routeCMRController.updatePayer(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updatePayer(this.routePartCMRId, Route_eCMRPartnerDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  payerBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.payerName || this.route_eCMR.payerNif || this.route_eCMR.payerContactName || this.route_eCMR.payerContactPhone || this.route_eCMR.payerAddress?.formattedAddress);
  }

  resetOriginAddress() {
    if (!this.external) {
      this.routeCMRController.updateOriginAddress(this.routePartCMRId, Route_eCMRAddressDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateOriginAddress(this.routePartCMRId, Route_eCMRAddressDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  originAddressBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.originAddressId || this.route_eCMR.originAddressKey || this.route_eCMR.originAddressName || this.route_eCMR.originAddress?.formattedAddress || this.route_eCMR.originContactPhone);
  }

  resetDestinationAddress() {
    if (!this.external) {
      this.routeCMRController.updateDestinationAddress(this.routePartCMRId, Route_eCMRAddressDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateDestinationAddress(this.routePartCMRId, Route_eCMRAddressDTO.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  destinationAddressBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.destinationAddressId || this.route_eCMR.destinationAddressKey || this.route_eCMR.destinationAddressName || this.route_eCMR.destinationAddress?.formattedAddress || this.route_eCMR.destinationContactPhone);
  }

  resetConditions() {
    if (!this.external) {
      this.routeCMRController.updateConditions(this.routePartCMRId, Route_eCMRConditionsDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateConditions(this.routePartCMRId, Route_eCMRConditionsDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  conditionsBlank(): boolean {
    return !this.route_eCMR || !this.route_eCMR.conditions || this.route_eCMR.conditions.length == 0;
  }

  resetHandlingAndTransportation() {
    if (!this.external) {
      this.routeCMRController.updateHandlingAndTransportation(this.routePartCMRId, Route_eCMRHandlingAndTransportationDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateHandlingAndTransportation(this.routePartCMRId, Route_eCMRHandlingAndTransportationDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  handlingAndTransportationBlank(): boolean {
    return !this.route_eCMR || !this.route_eCMR.handlingAndTransportation || this.route_eCMR.handlingAndTransportation.length == 0;
  }

  resetPlates() {
    if (!this.external) {
      this.routeCMRController.updatePlates(this.routePartCMRId, Route_eCMRPlatesDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updatePlates(this.routePartCMRId, Route_eCMRPlatesDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  platesBlank(): boolean {
    return !this.route_eCMR || !(this.route_eCMR.plateA || this.route_eCMR.plateB || this.route_eCMR.plateC);
  }

  resetTransportDate() {
    if (!this.external) {
      this.routeCMRController.updateTransportDate(this.routePartCMRId, Route_eCMRTransportDateDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateTransportDate(this.routePartCMRId, Route_eCMRTransportDateDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  transportDateBlank(): boolean {
    return !this.route_eCMR || !this.route_eCMR.transportDate;
  }

  resetDeliveryLines() {
    if (!this.external) {
      this.routeCMRController.updateDeliveryLines(this.routePartCMRId, Route_eCMRDeliveryLinesDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    } else {
      this.openRouteCMRController.updateDeliveryLines(this.routePartCMRId, Route_eCMRDeliveryLinesDto.buildReset()).subscribe(e => {
        if (e) {
          this.loadCMR();
        }
      });
    }
  }

  deliveryLinesBlank(): boolean {
    return !this.route_eCMR || !this.route_eCMR.deliveryLines || this.route_eCMR.deliveryLines.length == 0;
  }

  pretty(value: any): string {
    return JSON.stringify(value);
  }

}
